<template>
  <div>
    <div class="position-relative progress-bar-back">
      <div class="position-absolute progress-bar-front"
           :style="{ width: `${((value / max) * 100)}%` }"></div>
    </div>
    <div class="row">
      <div class="col">
        <b-spinner small/>
      </div>
      <div class="col-auto">
        <div class="text-right" v-if="value === max && max > 0">{{ $t('finishing_operation') }}</div>
        <div class="text-right" v-else>{{ value }} / {{ max }}</div>
      </div>
    </div>

  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
})
</script>

<style scoped lang="scss">
.progress-bar-back {
  width: 100%;
  height: 12px;
  margin: 16px 0;
  background-color: $calendar-time-color;
  border-radius: 10px;
  overflow: hidden;
}
.progress-bar-front {
  left: 0;
  top: 0;
  bottom: 0;
  background: $blue-color;
}
</style>
